import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import {
        Select,
        SelectContent,
        SelectGroup,
        SelectItem,
        SelectLabel,
        SelectTrigger,
        SelectValue,
    } from '@/components/ui/select';

    import { SelectOption } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
    placeholder: {},
    options: {},
    translate: { type: Boolean, default: false },
    valueBy: { default: 'value' },
    labelBy: { default: 'label' }
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const getOptionValue = (option: SelectOption | Record<string, any>): string => {
        return (option as Record<string, any>)[props.valueBy] ?? '';
    };

    const getOptionLabel = (option: SelectOption | Record<string, any>): string => {
        const label = (option as Record<string, any>)[props.labelBy];
        return props.translate ? t(label) : label;
    };

    const translatedOptions = computed(() =>
        props.options.map((option) => ({
            ...option,
            value: getOptionValue(option),
            label: getOptionLabel(option),
            addon: option.addon,
        })),
    );

    const placeholderWithDefault = props.placeholder || t('forms.select_placeholder');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Select), null, {
    default: _withCtx(() => [
      _createVNode(_unref(SelectTrigger), { class: "w-full" }, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectValue), { placeholder: _unref(placeholderWithDefault) }, null, 8, ["placeholder"])
        ]),
        _: 1
      }),
      _createVNode(_unref(SelectContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(SelectGroup), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translatedOptions.value, (option, index) => {
                return (_openBlock(), _createBlock(_unref(SelectItem), {
                  key: index,
                  value: option.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(option.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})